import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import PageHeader from '@/components/PageHeader';
import AdvanceShareStyleList from './advance-share-style-list';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Advance Share Style">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Advance Shares</Breadcrumb.Item>
            <Breadcrumb.Item active>Styles</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <AdvanceShareStyleList />
    </Panel>
  );
};

export default Page;
